import { TabStyles } from '@tableau/widgets';
import React from 'react';

import { cssClass } from '~src/style';

export type LensUsageAnalyticsProps = {
  lensId: string;
};

export const LensUsageAnalytics: React.FC<LensUsageAnalyticsProps> = props => {
  return <div className={exploringLayoutWrapperStyle}>
    <iframe
      id='lens-usage-analytics'
      title='Lens Usage Analytics'
      className={vizIframeStyle}
      src={getLensUsageAnalyticsVizUrl(props.lensId)} />
  </div>;
};
LensUsageAnalytics.displayName = 'LensUsageAnalytics';

const getLensUsageAnalyticsVizUrl = (lensId: string) => {
  const baseUrl = window.location.origin;
  return `${baseUrl}/vizql/showadminview/lenses/AskDataUsageAnalytics?lens_id=${lensId}`;
};

const cssPrefix = 'lensUsageAnalytics';
const vizIframeStyle = cssClass(cssPrefix, 'vizIframe', {
  border: 'none',
  width: '100%',
  height: '100%',
});

const exploringLayoutWrapperStyle = cssClass(cssPrefix, 'exploringLayoutWrapper', {
  top: '0px',
  bottom: '0px',
  left: '0px',
  right: '0px',
  position: 'absolute',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  backgroundColor: TabStyles.Colors.F1,
});
